import { ReactElement, useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { heapEvent } from '@equipmentshare/heaper'
import { PICK_ORDER_PREFIX } from '../constants'

type Props = {
	pickOrderNumber: number,
	disabled?: boolean,
	onConfirm: () => void,
}

/**
 * Abandons a run. The fulfillment orders in it go back to the queue and can be
 * picked again on a new run, so this ends the picking work rather than the
 * orders themselves.
 */
export default function CancelPickOrderButton( { pickOrderNumber, disabled, onConfirm }: Props ): ReactElement {
	const [ open, setOpen ] = useState( false )

	return (
		<>
			<Button
				color="inherit"
				disabled={disabled}
				onClick={() => {
					heapEvent( 'Inventory - DC Admin - Pick Order - Cancel - Open', { pick_order_number: pickOrderNumber } )
					setOpen( true )
				}}
			>
				Cancel pick order
			</Button>
			<Dialog open={open} onClose={() => setOpen( false )} maxWidth="xs" fullWidth>
				<DialogTitle>Cancel {PICK_ORDER_PREFIX}{pickOrderNumber}?</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Its orders can be picked on a new pick order. Put back anything already picked.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button color="inherit" onClick={() => setOpen( false )}>Keep picking</Button>
					<Button
						color="error"
						variant="contained"
						onClick={() => {
							setOpen( false )
							onConfirm()
						}}
					>
						Cancel pick order
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}
